/* WAVY-JADE-0926 | wavy-bogo.js (rewrite of the WAVY-JADE-0925 file: same maths + add path, new box)
   Jade "Buy 1, Get 1 50% Off": PDP offer tiles + compact second-piece slot + 3-step picker sheet + NZS-style
   two-line ATC + choose-first options, and the window.wjBogo API.
   - Server (automatic BXGY on collection "jade") is the price authority: across the WHOLE cart the floor(n/2)
     cheapest jade units get halfOff(). This file only chooses what goes in the cart and mirrors that maths as a
     MARGINAL quote against the jade already in the cart (unit prices from the drawer meter's data-wj-prices):
     pay = sum(new) - (save(cart + new) - save(cart)).   (proven live: /cart.js total == box pay)
   - Money: window.wjMoney (assets/wavy-money.js, contract 1). The embedded moneyFormat is only a fallback.
   - Price sync (SS16): on a variant change Shrine's global.js re-renders the section and publishes
     PUB_SUB_EVENTS.variantChange with the parsed document; the box reads [data-wj-cur] (selected variant of THAT
     render) from it, so the box and the price block always come from one render.
   - Choose-first (contract 4): every option with more than one value starts unselected. Dawn keeps its checked
     radio + hidden variant id (its own code needs them); this layer hides the selection until the shopper picks,
     writes "Length: Select" / "Length: 7 Inches (18cm)" into the legends and blocks the add ("Select a length").
   - ATC (contract 5): line 1 "ADD TO CART \u00b7 ~~$was~~ $now", line 2 (WAVY-CRO-1001) = price-aware free shipping: "Free shipping" when the
     amount the button adds is >= 70 USD in the shopper's currency, else "Add $X more for free shipping"; the server text
     (data-wj-atc-sub, "Arrives in 3\u20135 business days") shows only until JS paints or when the rate is unknown;
     busy dots -> tick 1.6 s -> back; sold out / unavailable copy the theme's own text. BOTH tiers add through
     ONE /cart/add.js with the drawer's sections, then cart-drawer.renderContents() (as assets/product-form.js).
   - Loaded site-wide with defer. The box initialises only when [data-wj-bogo] exists; the sheet is built lazily
     and also serves the cart drawer: wjBogo.open({preselectProductId, step: 2, mode: 'drawer'}).
   - Open/enter transitions start from a forced reflow, never requestAnimationFrame.
   - WAVY-CRO-1001B quick-add sheet: when the ATC (main or sticky) is pressed while options are missing ("Select a length" ...) the
     sheet opens instead of scrolling/nudging. Step 0 "Your piece" (page data-wj-page="0") configures THIS piece with the same pills as
     step 2 and writes every pick back to the page picker's own radios (pickP1), so page + sheet never disagree.
       single mode : only step 0, its button adds the variant (addItems, same path as the main button), drawer opens, sheet closes.
       pair mode   : step 0 -> 1 (grid) -> 2 (options) -> 3 (pair), or 0 -> 3 when a second piece is already chosen.
       pair mode, this piece already configured: unchanged (opens at step 1). API: wjBogo.quickAdd({trigger}). */
(function () {
  'use strict';
  if (window.wjBogo) return;

  var ICON_X = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_BACK = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.5 6l-6 6 6 6"/></svg>';
  var ICON_CARET = '<svg class="wj-dd__caret" viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9.5l6 6 6-6"/></svg>';
  var ICON_TICK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path pathLength="1" d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';

  /* ================================ helpers ================================ */
  function reduced() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function readJSON(el) { if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }
  function track(action, extra) {
    window.dataLayer = window.dataLayer || [];
    var o = { event: 'wj_bogo', action: action };
    if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) o[k] = extra[k];
    window.dataLayer.push(o);
  }
  function restart(el, cls) { if (!el) return; el.classList.remove(cls); el.getBoundingClientRect(); el.classList.add(cls); }

  /* ---------------- money: wjMoney first, embedded format (currency-code rule) as fallback ---------------- */
  var moneyFormat = '';
  function setMoneyFormat(f) { if (typeof f === 'string' && f) moneyFormat = f; }
  function groupNum(cents, dec, th, dp) {
    var parts = (Math.abs(cents) / 100).toFixed(dec).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th);
    return (cents < 0 ? '-' : '') + whole + (parts[1] ? dp + parts[1] : '');
  }
  function activeCurrency() { return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || ''; }
  function localFormat(cents) {
    cents = Math.round(Number(cents) || 0);
    var fmt = moneyFormat, plain = fmt.replace(/<[^>]*>/g, ''), cur = activeCurrency();
    if (!fmt || (cur && plain.indexOf(cur) === -1 && !/[$\u20ac\u00a3\u00a5]/.test(plain))) {
      try { return new Intl.NumberFormat('en', { style: 'currency', currency: cur || 'USD' }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2); }
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return plain;
    var v;
    switch (m[1]) {
      case 'amount_no_decimals': v = groupNum(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = groupNum(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = groupNum(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = groupNum(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = groupNum(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': v = groupNum(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = groupNum(cents, 2, ' ', '.'); break;
      default: v = groupNum(cents, 2, ',', '.');
    }
    return fmt.replace(m[0], v).replace(/<[^>]*>/g, '').trim();
  }
  function formatMoney(cents) {
    if (window.wjMoney && typeof window.wjMoney.format === 'function') return window.wjMoney.format(cents);
    return localFormat(cents);
  }

  /* WAVY-CRO-1001: free-shipping line under the ATC. Threshold = 70 USD x Shopify.currency.rate (presentment cents), read
     fresh on every paint so a Markets / currency switch is picked up. Returns null when the rate is unknown so the
     server-rendered text stays (never a made-up figure). */
  var FREE_SHIP_USD_CENTS = 7000;
  function freeShipThreshold() {
    var c = window.Shopify && window.Shopify.currency, cur = c && c.active, rate = c ? parseFloat(c.rate) : NaN;
    if (!(rate > 0)) { if (cur && cur !== 'USD') return null; rate = 1; }
    return Math.round(FREE_SHIP_USD_CENTS * rate);
  }
  function shipLine(amount) {
    var t = freeShipThreshold();
    if (t == null || !(amount > 0)) return '';
    return amount >= t ? 'Free shipping' : 'Add ' + formatMoney(t - amount) + ' more for free shipping';
  }

  /* Rounding rule (review #2): never UNDER-state the pay. A single discounted unit saves floor(price/2); discounted
     units that share a price are one line to Shopify, so the group saves floor(k * price / 2) (exact for an even k).
     Worst case the box shows 1 cent ABOVE what the cart charges (USD .95 prices on separate lines), never below.
     NZD presentment prices are whole dollars, so there the figures are exact. */
  function halfOff(cents) { return Math.floor(cents / 2); }
  /* save(S): the floor(|S|/2) cheapest units, grouped by unit price */
  function saveOf(units) {
    var s = units.slice().sort(function (a, b) { return a - b; }), k = Math.floor(s.length / 2);
    var groups = {}, order = [], t = 0;
    for (var i = 0; i < k; i++) { var p = s[i]; if (!groups[p]) { groups[p] = 0; order.push(p); } groups[p] += 1; }
    order.forEach(function (p) { t += Math.floor(groups[p] * p / 2); });
    return t;
  }
  /* Marginal quote for adding `add` (unit cents) to a cart holding jade units `cart`.
     off[i] = new unit i sits in the discounted cheapest set (ties: cart units first, then the later new unit). */
  function quote(cart, add) {
    cart = cart || [];
    var strike = add.reduce(function (a, c) { return a + c; }, 0);
    var save = saveOf(cart.concat(add)) - saveOf(cart);
    var all = cart.map(function (p) { return { p: p, n: -1 }; }).concat(add.map(function (p, i) { return { p: p, n: i }; }));
    all.sort(function (a, b) { return (a.p - b.p) || ((a.n < 0 || b.n < 0) ? a.n - b.n : b.n - a.n); });
    var k = Math.floor(all.length / 2), off = add.map(function () { return false; });
    for (var i = 0; i < k; i++) if (all[i].n >= 0) off[all[i].n] = true;
    return { strike: strike, save: save, pay: strike - save, off: off };
  }
  /* stand-alone pair (empty cart), kept for the step-3 rows and the public API */
  function pairMath(a, b) {
    var hi = Math.max(a, b), lo = Math.min(a, b), q = quote([], [a, b]);
    return { hi: hi, lo: lo, half: lo - halfOff(lo), pay: q.pay, strike: q.strike, save: q.save };
  }

  /* Jade unit prices already in the cart (presentment cents, one per unit). The drawer is in every page's DOM and
     re-renders on each cart change; without a drawer, fall back to the box's Liquid snapshot. */
  function parsePrices(v) { return String(v || '').split(',').map(Number).filter(function (n) { return n > 0; }); }
  function readCartUnits(st) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) { var m = drawer.querySelector('[data-wj-meter]'); return parsePrices(m && m.getAttribute('data-wj-prices')); }
    return parsePrices(st && st.box && st.box.getAttribute('data-wj-cart-prices'));
  }

  /* 300 ms number tween on setTimeout (not rAF, which starves in hidden tabs) */
  function tween(el, to, render, ms) {
    if (!el) return;
    clearTimeout(el._wjT);
    var from = typeof el._wjV === 'number' ? el._wjV : null;
    if (reduced() || from === null || from === to) { el._wjV = to; el.textContent = render(to); return; }
    var t0 = Date.now(), dur = ms || 300;
    (function step() {
      var k = Math.min(1, (Date.now() - t0) / dur), e = 1 - Math.pow(1 - k, 3);
      el._wjV = k < 1 ? Math.round(from + (to - from) * e) : to;
      el.textContent = render(el._wjV);
      if (k < 1) el._wjT = setTimeout(step, 16);
    })();
  }
  function setText(el, text) { if (!el) return; clearTimeout(el._wjT); el._wjV = null; el.textContent = text; }
  /* WAVY-CART-0928: the small struck compare-at beside a price; shown only when the data carries one above the price */
  function setWas(el, was, now) {
    if (!el) return;
    var on = was > 0 && was > now;
    el.hidden = !on;
    el.textContent = on ? formatMoney(was) : '';
  }
  function wasHTML(was, now, cls) {
    return was > 0 && was > now ? ' <s class="' + cls + '">' + esc(formatMoney(was)) + '</s>' : '';
  }
  function lowVariant(vs) {
    var lo = null;
    vs.forEach(function (v) { if (!lo || v.price < lo.price) lo = v; });
    return lo;
  }

  function minPrice(vs) { return vs.length ? Math.min.apply(null, vs.map(function (v) { return v.price; })) : 0; }
  function isDefaultOnly(p) {
    return !p.options.length || (p.options.length === 1 && p.options[0].values.length === 1 && p.options[0].values[0] === 'Default Title');
  }
  function varLabel(v) { return !v || v.title === 'Default Title' ? '' : v.title; }
  function findVariant(p, vid) { for (var i = 0; i < p.variants.length; i++) if (p.variants[i].id === vid) return p.variants[i]; return null; }
  /* "Select a length" / "Select a chain style" (contract 4 copy, option order) */
  function selectLabel(name) {
    var n = String(name || 'option').replace(/\s*\(.*$/, '').trim().toLowerCase(); /* WAVY-JADE-0926: drop '(Sterling Silver)' */
    if (n.length > 3 && /s$/.test(n) && !/ss$/.test(n)) n = n.slice(0, -1);
    return 'Select ' + (/^[aeiou]/.test(n) ? 'an ' : 'a ') + n;
  }

  /* ================================ cart (one add, theme drawer renders) ================================ */
  function cartDrawer() { return document.querySelector('cart-drawer'); }
  function addUrl() { return ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js'; }
  function mergeItems(ids) {
    var order = [], qty = {};
    ids.forEach(function (id) { if (!qty[id]) { qty[id] = 0; order.push(id); } qty[id] += 1; });
    return order.map(function (id) { return { id: id, quantity: qty[id] }; });
  }
  /* Resolves with the /cart/add.js response after the drawer re-render; rejects with {message} on 422 / network. */
  function addItems(items, opts) {
    opts = opts || {};
    var cart = cartDrawer();
    var body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (opts.trigger && typeof cart.setActiveElement === 'function') cart.setActiveElement(opts.trigger);
    }
    return fetch(addUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok || d.status) {
          var err = new Error(d.description || d.message || 'That piece couldn\u2019t be added. Please try again.');
          err.data = d; throw err;
        }
        return d;
      });
    }).then(function (res) {
      if (!cart || !res.sections) { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; return res; }
      /* same hand-off as assets/product-form.js: publish, then let the drawer render and open itself.
         The add already succeeded, so a render failure goes to the cart page instead of reporting an error. */
      try {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wavy-bogo' });
        cart.renderContents(res);
        cart.classList.remove('is-empty');
      } catch (e) {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        return res;
      }
      refreshCartUnits();
      return res;
    });
  }

  /* ================================ PDP box ================================ */
  var boxes = [];

  function boxState(box) {
    if (box._wj) return box._wj;
    var data = readJSON(box.querySelector('[data-wj-bogo-catalog]')) || {};
    setMoneyFormat(data.moneyFormat);
    var map = {}, list = [];
    (data.products || []).forEach(function (p) { if (p && p.variants && p.variants.length && !map[p.id]) { map[p.id] = p; list.push(p); } });
    var info = box.closest('product-info');
    var section = box.getAttribute('data-section') || (info && info.getAttribute('data-section')) || '';
    var form = (section && document.getElementById('product-form-' + section)) ||
      (box.closest('.shopify-section') && box.closest('.shopify-section').querySelector('form[data-type="add-to-cart-form"]')) ||
      document.querySelector('product-form form');
    var st = {
      box: box,
      info: info,
      pid: Number(box.getAttribute('data-product-id')),
      cur: data.current || { variants: [] },
      map: map,
      list: list,
      form: form,
      mode: box.getAttribute('data-mode') || 'pair',
      section: section,
      atcSub: box.getAttribute('data-wj-atc-sub') || '',
      cart: [],
      opts: [],
      unavail: false,
      gotInput: false,
      slot1: 0,
      slot2: null,
      busy: false
    };
    /* the selected variant of this render is the source of truth for its price (same render as the price block) */
    var cur = readJSON(box.querySelector('[data-wj-cur]'));
    if (cur && cur.id) mergeCur(st, cur);
    box._wj = st;
    return st;
  }
  function curVariant(st, id) { for (var i = 0; i < st.cur.variants.length; i++) if (st.cur.variants[i].id === id) return st.cur.variants[i]; return null; }
  function mergeCur(st, cur) {
    var v = curVariant(st, cur.id);
    if (v) {
      v.price = cur.price; v.compare = cur.compare || 0; v.available = !!cur.available;
      if (cur.img) v.img = cur.img;
      if (cur.title != null && cur.title !== '') v.title = cur.title;
    } else {
      st.cur.variants.push({ id: cur.id, title: cur.title || '', price: cur.price, compare: cur.compare || 0, available: !!cur.available, img: cur.img || null });
    }
  }
  function firstId(val) { return Number(String(val || '').split(',')[0]) || 0; }
  function slot1Variant(st) { return st.unavail ? null : curVariant(st, st.slot1); }
  function slot2Data(st) {
    if (!st.slot2) return null;
    var p = st.map[st.slot2.pid], v = p && findVariant(p, st.slot2.vid);
    return v ? { p: p, v: v } : null;
  }
  function setStatus(st, msg) { var s = st.box.querySelector('[data-wj-status]'); if (s) s.textContent = msg || ''; }

  /* ---------------- choose-first options (contract 4) ---------------- */
  function initOptions(st) {
    var scope = st.info || (st.form && st.form.closest('.shopify-section')) || document;
    var picker = (st.section && document.getElementById('variant-radios-' + st.section)) || scope.querySelector('variant-radios');
    st.picker = picker;
    st.opts = [];
    if (picker) {
      /* deep links (?variant= from Google Shopping / cart links) arrive with a chosen variant: nothing is pending */
      var deep = /[?&]variant=\d+/.test(window.location.search || '');
      Array.prototype.forEach.call(picker.querySelectorAll('fieldset'), function (fs, i) {
        var legend = fs.querySelector('legend');
        var name = legend ? legend.textContent.trim() : ('Option ' + (i + 1));
        var multi = fs.querySelectorAll('input[type="radio"]').length > 1;
        fs.classList.add('wj-opt');
        if (!multi || deep) fs.classList.add('is-chosen');
        if (legend && !legend.querySelector('[data-wj-opt-val]')) {
          legend.innerHTML = '<span class="wj-opt__name">' + esc(name) + '</span><span class="wj-opt__val" data-wj-opt-val></span>';
        }
        st.opts.push({ name: name, fs: fs, multi: multi, legend: legend });
      });
    }
    placeSizeGuide(st);
    syncLegends(st);
  }
  /* "Length: 7 Inches (18cm) \u00b7 Size guide": the size-guide trigger moves into the first option's legend */
  function placeSizeGuide(st) {
    var scope = st.info || document;
    var anchor = scope.querySelector('[data-wj-sg-anchor]');
    var btn = anchor && anchor.querySelector('[data-wj-sg]');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'wj-sg-link';
      btn.setAttribute('data-wj-sg', '');
      btn.setAttribute('data-wj-sg-type', st.box.getAttribute('data-wj-sg-type') || 'bracelet');
      btn.setAttribute('data-wj-sg-widths', st.box.getAttribute('data-wj-sg-widths') || '');
      btn.setAttribute('aria-haspopup', 'dialog');
      btn.setAttribute('aria-controls', 'WjSizeGuide');
      btn.textContent = 'Size guide';
    }
    var first = st.opts[0];
    if (first && first.legend) {
      var sep = document.createElement('span');
      sep.className = 'wj-opt__sep'; sep.setAttribute('aria-hidden', 'true'); sep.textContent = '\u00b7';
      first.legend.appendChild(sep);
      first.legend.appendChild(btn);
      if (anchor) anchor.hidden = true;
    } else if (anchor) {
      anchor.classList.add('is-shown'); /* no picker (one variant): keep the row */
    } else if (st.box.parentNode) {
      var row = document.createElement('div');
      row.className = 'wj-sg-anchor is-shown';
      row.appendChild(btn);
      st.box.insertAdjacentElement('afterend', row);
    }
  }
  function pending(st) {
    return st.opts.filter(function (o) { return o.multi && !o.fs.classList.contains('is-chosen'); });
  }
  function syncLegends(st) {
    st.opts.forEach(function (o) {
      var val = o.legend && o.legend.querySelector('[data-wj-opt-val]');
      var chosen = o.fs.classList.contains('is-chosen');
      var checked = o.fs.querySelector('input[type="radio"]:checked');
      o.fs.classList.toggle('is-pending', !chosen);
      if (val) val.textContent = ': ' + (chosen && checked ? checked.value : 'Select');
    });
  }
  function markChosen(st, fs) {
    if (!fs) return;
    var was = fs.classList.contains('is-chosen');
    fs.classList.add('is-chosen');
    syncLegends(st);
    if (!was) { setStatus(st, ''); paintBox(st); }
  }
  function nudgeOption(o) {
    if (!o) return;
    if (!reduced()) restart(o.fs, 'is-nudged');
    var r = o.fs.querySelector('input[type="radio"]:checked') || o.fs.querySelector('input[type="radio"]');
    if (r) r.focus();
  }

  /* ---------------- second-piece slot ---------------- */
  /* showHalf=false when other cart jade shares the discount: the per-piece figure would not add up to "You pay" */
  /* WAVY-JADE-0926 (Blake): the half comes off the SELL price (struck sell -> half); a full-price piece shows its compare-at */
  function slotPriceHTML(price, discounted, showHalf, compare) {
    if (!discounted) return (compare > price ? '<s>' + esc(formatMoney(compare)) + '</s> ' : '') + '<span>' + esc(formatMoney(price)) + '</span>';
    if (!showHalf) return '<span>' + esc(formatMoney(price)) + '</span><span class="wj-off">50% off</span>';
    return '<s>' + esc(formatMoney(price)) + '</s> <span>' + esc(formatMoney(price - halfOff(price))) + '</span><span class="wj-off">50% off</span>';
  }
  /* per-piece halves are shown only when they add up to the quote's saving (always with an empty cart; cart jade can
     move the discount onto a cart line, and then the cart line explains it) */
  function halvesAddUp(q, prices) {
    var t = 0;
    prices.forEach(function (p, i) { if (q.off[i]) t += halfOff(p); });
    return t === q.save;
  }
  function paintSlot2(st, animate) {
    var el = st.box.querySelector('[data-wj-slot="2"]'), d = slot2Data(st);
    if (!el) return;
    /* WAVY-JADE-0926 BOXDD: empty = the opener button; filled = a row whose pills drop down in place */
    var want = d ? 'DIV' : 'BUTTON';
    if (el.tagName !== want) {
      var nx = document.createElement(want.toLowerCase());
      nx.className = 'wj-slot2';
      nx.setAttribute('data-wj-slot', '2');
      if (want === 'BUTTON') { nx.type = 'button'; nx.setAttribute('data-wj-open-sheet', ''); nx.setAttribute('aria-haspopup', 'dialog'); }
      el.parentNode.replaceChild(nx, el);
      el = nx;
    }
    if (!d) {
      el.classList.add('is-empty');
      el.removeAttribute('aria-label');
      el.innerHTML =
        '<span class="wj-slot2__media" aria-hidden="true">' + ICON_PLUS + '</span>' +
        '<span class="wj-slot2__text"><span class="wj-slot2__micro">Second piece</span>' +
        '<span class="wj-slot2__main">Choose a piece <span class="wj-slot2__chev" aria-hidden="true">\u203a</span></span></span>';
      return;
    }
    el.classList.remove('is-empty');
    var vt = varLabel(d.v), dd = ddHTML('b2', d.p, d.v.options);
    el.innerHTML =
      '<span class="wj-slot2__media" aria-hidden="true">' + (d.p.img ? '<img src="' + esc(d.p.img) + '" alt="" width="40" height="40" decoding="async">' : '') + '</span>' +
      '<span class="wj-slot2__text"><span class="wj-slot2__micro">Second piece</span>' +
        '<span class="wj-slot2__main"><strong>' + esc(d.p.title) + '</strong>' + (!dd && vt ? '<span class="wj-slot2__var"> \u00b7 ' + esc(vt) + '</span>' : '') + '</span>' +
        (d.p.sub ? '<span class="wj-slot2__sub">' + esc(d.p.sub) + '</span>' : '') + '</span>' + /* WAVY-CRO-1001C: style line, as on the cards */
      '<span class="wj-slot2__right"><span class="wj-slot2__price" data-wj-s2-price></span>' +
        '<button type="button" class="wj-slot2__change" data-wj-open-sheet aria-haspopup="dialog" aria-label="Change the second piece">Change</button></span>' + dd;
    if (animate && !reduced()) restart(el, 'is-updated');
  }

  /* current marginal quote for the selected tier (null when it can't be priced yet) */
  function tierQuote(st) {
    var v1 = slot1Variant(st), d2 = slot2Data(st);
    if (!v1) return null;
    if (st.mode === 'single') return quote(st.cart, [v1.price]);
    return d2 ? quote(st.cart, [v1.price, d2.v.price]) : null;
  }
  function paintBox(st) {
    var b = st.box, v1 = slot1Variant(st), d2 = slot2Data(st), cart = st.cart || [];
    var p1 = v1 ? v1.price : 0, qp = null;
    b.setAttribute('data-mode', st.mode);
    b.querySelectorAll('[data-wj-tier]').forEach(function (t) { t.classList.toggle('is-selected', t.getAttribute('data-wj-tier') === st.mode); });

    /* "Just this piece" always shows its own price, never struck (a cart-jade saving is its own line + the ATC) */
    var single = b.querySelector('[data-wj-single-price]');
    if (v1) tween(single, p1, formatMoney); else setText(single, 'Unavailable');
    setWas(b.querySelector('[data-wj-single-was]'), v1 ? v1.compare : 0, p1); /* WAVY-CART-0928 */

    var pay = b.querySelector('[data-wj-pair-pay]'), from = b.querySelector('[data-wj-pair-from]');
    var pairWas = b.querySelector('[data-wj-pair-was]'); /* WAVY-CART-0928 */
    if (v1 && d2) {
      qp = quote(cart, [p1, d2.v.price]);
      if (from) from.hidden = true;
      tween(pay, qp.pay, formatMoney);
      /* WAVY-CART-0928: the pair's compare-at = both pieces' compare-at, only when both carry one */
      setWas(pairWas, v1.compare > p1 && d2.v.compare > d2.v.price ? v1.compare + d2.v.compare : 0, qp.pay);
    } else if (v1) {
      /* WAVY-JADE-0926 (Blake): no second piece yet = the pair tile matches this piece; the real total shows once one is picked */
      if (from) from.hidden = true;
      tween(pay, p1, formatMoney);
      setWas(pairWas, v1.compare, p1); /* WAVY-CART-0928 */
    } else {
      if (from) from.hidden = true;
      setText(pay, 'Unavailable');
      setWas(pairWas, 0, 0); /* WAVY-CART-0928 */
    }
    var s2Price = b.querySelector('[data-wj-s2-price]');
    if (s2Price && d2) s2Price.innerHTML = slotPriceHTML(d2.v.price, qp ? qp.off[1] : false, qp ? halvesAddUp(qp, [p1, d2.v.price]) : false, d2.v.compare);

    /* one short line, only when the cart already holds jade and this add creates a saving on it */
    var line = b.querySelector('[data-wj-cartline]');
    if (line) {
      var q = cart.length && v1 ? (st.mode === 'pair' && qp ? qp : quote(cart, [p1])) : null;
      /* WAVY-CRO-1001C (Blake): the "Pairs with the jade in your cart: saves ..." line is removed */
      if (q && q.save < 0) {
        /* the discount migrates onto the cheaper new piece(s): say what the cart will actually rise by */
        line.hidden = false;
        line.textContent = (st.mode === 'pair' && qp ? 'This pair takes' : 'This piece takes') +
          ' the 50% off from your pair, so your total rises by ' + formatMoney(q.pay) + '.';
      } else line.hidden = true;
    }
    paintSlot1(st, qp);
    paintLabel(st);
    refreshPair(st);
    refreshPiece(st); /* WAVY-CRO-1001B */
  }
  /* WAVY-JADE-0926 PAIRDD: once the pair is complete, the box shows BOTH pieces; this row follows the page picker */
  function paintSlot1(st, qp) {
    var inner = st.box.querySelector('.wj-bogo__slot-inner'); if (!inner) return;
    var el = inner.querySelector('[data-wj-slot="1"]');
    var d2 = slot2Data(st), v1 = slot1Variant(st), p1 = st.map[st.pid];
    var show = !!(d2 && v1 && p1);
    if (!el) {
      if (!show) return;
      el = document.createElement('div');
      el.className = 'wj-slot2 wj-slot1';
      el.setAttribute('data-wj-slot', '1');
      inner.insertBefore(el, inner.firstChild);
    }
    el.hidden = !show;
    if (!show) return;
    var pend = pending(st), vt = pend.length ? '' : varLabel(v1), img = v1.img || p1.img;
    var dd = st.opts.length === p1.options.length ? ddHTML('b1', p1, p1Sel(st)) : '';
    el.innerHTML =
      '<span class="wj-slot2__media" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" width="40" height="40" decoding="async">' : '') + '</span>' +
      '<span class="wj-slot2__text"><span class="wj-slot2__micro">This piece</span>' +
        '<span class="wj-slot2__main"><strong>' + esc(p1.title) + '</strong>' +
        (dd ? '' : pend.length ? '<span class="wj-slot2__var wj-slot1__pend"> · ' + esc(selectLabel(pend[0].name)) + ' above</span>'
          : vt ? '<span class="wj-slot2__var"> · ' + esc(vt) + '</span>' : '') + '</span>' +
        (p1.sub ? '<span class="wj-slot2__sub">' + esc(p1.sub) + '</span>' : '') + '</span>' + /* WAVY-CRO-1001C */
      '<span class="wj-slot2__right"><span class="wj-slot2__price">' + slotPriceHTML(v1.price, qp ? qp.off[0] : false, qp ? halvesAddUp(qp, [v1.price, d2.v.price]) : false, v1.compare) + '</span></span>' + dd;
  }

  /* ---------------- ATC: two-line label (own span beside the theme's; the theme keeps writing its span) ---------------- */
  function wireAtc(st) {
    var btn = st.form && st.form.querySelector('[name="add"]');
    if (!btn || btn._wjWired) return;
    btn._wjWired = true;
    st.btn = btn;
    var src = btn.querySelector(':scope > span');
    st.src = src;
    var lab = document.createElement('span');
    lab.className = 'wj-atc-label';
    lab.innerHTML =
      '<span class="wj-atc-l1"><span class="wj-atc-text"></span>' +
        '<span class="wj-atc-price" hidden><span class="wj-atc-sep" aria-hidden="true">\u00b7</span><s class="wj-atc-was" hidden></s><span class="wj-atc-now"></span></span></span>' +
      '<span class="wj-atc-sub" hidden></span>' +
      '<span class="wj-atc-dots" aria-hidden="true"><i></i><i></i><i></i></span>' +
      '<span class="wj-atc-done" aria-hidden="true">' + ICON_TICK + '<span>Added</span></span>';
    /* after the theme span, so global.js `[name="add"] > span` still finds the theme's own span first */
    if (src) src.insertAdjacentElement('afterend', lab); else btn.insertBefore(lab, btn.firstChild);
    btn.classList.add('wj-atc');
    st.label = lab;
    st.el = {
      text: lab.querySelector('.wj-atc-text'), price: lab.querySelector('.wj-atc-price'),
      was: lab.querySelector('.wj-atc-was'), now: lab.querySelector('.wj-atc-now'), sub: lab.querySelector('.wj-atc-sub'), l1: lab.querySelector('.wj-atc-l1')
    };
    var mo = new MutationObserver(function () { paintLabel(st); });
    if (src) mo.observe(src, { childList: true, characterData: true, subtree: true });
    mo.observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    st._mo = mo;
    st.sticky = st.form.id ? document.querySelector('button[form="' + st.form.id + '"][name="add"]') : null;
    if (st.sticky) { var ss = st.sticky.querySelector(':scope > span'); st.stickySpan = ss; st.stickyText = ss ? ss.textContent : ''; }
  }
  /* what the button should say right now: {text, was, now, sub, blocked, pick} */
  function labelState(st) {
    var themeText = st.src ? st.src.textContent.trim() : '';
    var VS = window.variantStrings || {};
    var addText = VS.addToCart || 'Add to cart';
    var v1 = slot1Variant(st), d2 = slot2Data(st), cart = st.cart || [];
    if (st.btn && st.btn.disabled && themeText && themeText !== addText) return { text: themeText, sub: false }; /* Sold out / Unavailable */
    if (st.unavail) return { text: VS.unavailable || 'Unavailable', sub: false };
    var pend = pending(st);
    if (pend.length) return { text: selectLabel(pend[0].name), sub: false, blocked: true };
    if (!v1) return { text: themeText || addText, sub: false };
    if (!v1.available) return { text: VS.soldOut || 'Sold out', sub: false };
    if (st.mode === 'pair') {
      if (!d2) return { text: 'Choose your second piece', sub: false, pick: true };
      var q = quote(cart, [v1.price, d2.v.price]);
      /* WAVY-CRO-1001C (Blake): the struck figure is the pair's total compare-at (each piece's compare-at, or its price
         when it has none), the same figure the Pair tile strikes; shown only when it is above what the pair costs */
      var wasPair = (v1.compare > v1.price ? v1.compare : v1.price) + (d2.v.compare > d2.v.price ? d2.v.compare : d2.v.price);
      return { text: 'Add pair to cart', was: wasPair > q.pay ? wasPair : 0, now: q.pay, ship: q.pay, sub: true }; /* WAVY-CRO-1001: ship = amount the free-shipping line compares */
    }
    var qs = quote(cart, [v1.price]);
    /* save < 0: an even cart + a cheaper piece moves the 50% onto this piece, so the cart rises by MORE than its price.
       Show the real increase (pay) against the piece's own price: never a number the cart won't charge. */
    /* WAVY-JADE-0926: a negative save (shift) shows the real increase with no strike; a strike under a larger number reads wrong */
    var wasOne = v1.compare > v1.price ? v1.compare : v1.price; /* WAVY-CRO-1001C: compare-at, as above */
    if (qs.save !== 0) return { text: 'Add to cart', was: qs.save > 0 && wasOne > qs.pay ? wasOne : null, now: qs.pay, ship: v1.price, sub: true };
    return { text: 'Add to cart', was: v1.compare > v1.price ? v1.compare : 0, now: v1.price, ship: v1.price, sub: true };
  }
  function paintLabel(st) {
    if (!st.label) return;
    var L = labelState(st), E = st.el;
    var changed = E.text.textContent !== L.text;
    E.text.textContent = L.text;
    E.price.hidden = !(L.now > 0);
    if (L.now > 0) {
      E.was.hidden = !(L.was > 0);
      E.was.textContent = L.was > 0 ? formatMoney(L.was).replace(/\s*[A-Z]{3}$/, '') : ''; /* WAVY-CRO-1001C: currency code once per button (on the pay figure) */
      E.now.textContent = formatMoney(L.now);
    }
    /* WAVY-CRO-1001: price-aware second line; L.now is the amount the button adds (pair: after the 50% off) */
    var subText = L.sub ? (shipLine(L.ship != null ? L.ship : L.now) || st.atcSub) : ''; /* item price, not the cart-adjusted increase (Blake: no cart-aware subtraction) */
    var sub = !!subText;
    E.sub.hidden = !sub;
    if (sub) E.sub.textContent = subText;
    st.btn.classList.toggle('is-blocked', !!L.blocked);
    st.btn.classList.toggle('is-pick', !!L.pick);
    if (changed && st.labelReady && !reduced()) restart(E.l1, 'is-morph');
    st.labelReady = true;
    if (st.stickySpan && !st.sticky.disabled) st.stickySpan.textContent = L.blocked ? L.text : (st.mode === 'pair' ? 'Add pair to cart' : st.stickyText);
  }
  function setBusy(st, on) {
    var btn = st.btn; if (!btn) return;
    st.busy = on;
    if (on) { btn.classList.add('is-busy'); btn.setAttribute('aria-disabled', 'true'); }
    else { btn.classList.remove('is-busy'); btn.removeAttribute('aria-disabled'); }
  }
  function setAdded(st) {
    var btn = st.btn; if (!btn) return;
    clearTimeout(st._addedT);
    btn.classList.add('is-added');
    st._addedT = setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
  }

  /* one add path for both tiers: validate (choose-first, stock, second piece), then ONE request */
  function addNow(st) {
    if (st.busy) return;
    setStatus(st, '');
    if (st.unavail) { setStatus(st, 'This combination is unavailable. Please choose another option above.'); return; }
    var pend = pending(st);
    if (pend.length) {
      /* WAVY-CRO-1001B: quick-add sheet instead of the status line + focus nudge (kept as the fallback when the sheet cannot open) */
      if (openQuick(st, st.btn)) return;
      setStatus(st, selectLabel(pend[0].name) + ' to continue.'); nudgeOption(pend[0]); return;
    }
    var v1 = slot1Variant(st);
    if (!v1 || !v1.available) { setStatus(st, 'This option is sold out. Please choose another option above.'); return; }
    var items, qv, ev;
    if (st.mode === 'pair') {
      var d2 = slot2Data(st);
      if (!d2) {
        setStatus(st, 'Choose your second piece to complete the pair.');
        openSheet({ st: st, mode: 'pdp', step: 1, trigger: st.btn });
        return;
      }
      items = mergeItems([v1.id, d2.v.id]);
      qv = quote(st.cart, [v1.price, d2.v.price]); /* marginal, quoted before the cart changes */
      ev = { mode: 'pair', product_id: st.pid, second_product_id: d2.p.id, value: qv.pay / 100 };
    } else {
      items = [{ id: v1.id, quantity: 1 }];
      qv = quote(st.cart, [v1.price]);
      ev = { mode: 'single', product_id: st.pid, value: qv.pay / 100 };
    }
    setBusy(st, true);
    addItems(items, { trigger: st.btn }).then(function () {
      track('add', ev);
      setAdded(st);
    }).catch(function (err) {
      setStatus(st, (err && err.message) || 'That piece couldn\u2019t be added. Please try again.');
    }).then(function () { setBusy(st, false); });
  }

  /* a fresh section render (Shrine global.js renderProductInfo): take the selected variant of THAT render */
  function applyFreshRender(st, doc, variant) {
    var freshBox = doc && doc.querySelector && (doc.querySelector('[data-wj-bogo][data-product-id="' + st.pid + '"]') || doc.querySelector('[data-wj-bogo]'));
    var cur = freshBox ? readJSON(freshBox.querySelector('[data-wj-cur]')) : null;
    if (!cur || !cur.id) {
      if (variant && variant.id && curVariant(st, variant.id)) { st.slot1 = variant.id; st.unavail = false; paintBox(st); }
      return;
    }
    var cat = readJSON(freshBox.querySelector('[data-wj-bogo-catalog]'));
    if (cat && cat.current && cat.current.variants && cat.current.variants.length) st.cur = cat.current;
    mergeCur(st, cur);
    st.slot1 = cur.id;
    st.unavail = false;
    var cp = freshBox.getAttribute('data-wj-cart-prices');
    if (cp != null) st.box.setAttribute('data-wj-cart-prices', cp);
    setStatus(st, '');
    paintBox(st);
  }

  function initBox(box) {
    if (box._wjInit) return;
    box._wjInit = true;
    var st = boxState(box);
    boxes.push(st);
    var input = st.form && st.form.querySelector('[name="id"]');
    var wanted = firstId(input && (input.getAttribute('data-selected-id') || input.value));
    st.slot1 = (wanted && curVariant(st, wanted)) ? wanted
      : (st.cur.variants.filter(function (v) { return v.available; })[0] || st.cur.variants[0] || {}).id || 0;
    var checked = box.querySelector('[data-wj-tier-input]:checked');
    st.mode = checked ? checked.value : 'pair';
    st.cart = readCartUnits(st);
    if (st.form) {
      st.form._wjBogo = st;
      /* global.js updateVariantInput() sets the hidden id and dispatches a bubbling change (before its fetch) */
      st.form.addEventListener('change', function (e) {
        if (!e.target || e.target.name !== 'id') return;
        var id = firstId(e.target.getAttribute('data-selected-id') || e.target.value);
        st.gotInput = true;
        if (!id) return;
        st.slot1 = id; st.unavail = false; setStatus(st, ''); paintBox(st);
      });
    }
    wireAtc(st);
    initOptions(st);
    paintSlot2(st, false);
    paintBox(st);
    box.classList.add('is-ready');

    /* impression once, when half the box is visible */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); track('impression', { product_id: st.pid }); }
      }, { threshold: 0.5 });
      io.observe(box);
    } else track('impression', { product_id: st.pid });

    /* warm the first six picker images so the sheet opens with pictures */
    setTimeout(function () {
      st.list.slice(0, 6).forEach(function (p) { if (p.img) { var im = new Image(); im.decoding = 'async'; im.src = p.img; } });
    }, 1200);
  }

  /* ================================ sheet ================================ */
  var sh = { root: null, ctx: null, step: 1, pid: 0, sel: [], vid: 0, filter: 'all', trigger: null, closeT: 0, busy: false, openId: 0, escAt: 0 };

  function sheetRoot() {
    if (sh.root) return sh.root;
    var d = document.createElement('div');
    d.className = 'wj-sheet';
    d.hidden = true;
    d.innerHTML =
      '<div class="wj-sheet__scrim" data-wj-close></div>' +
      '<section class="wj-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="WjSheetTitle" aria-describedby="WjSheetSub" tabindex="-1">' +
        '<div class="wj-sheet__grip" aria-hidden="true"></div>' +
        '<header class="wj-sheet__head">' +
          '<button type="button" class="wj-sheet__icon wj-sheet__back" data-wj-back aria-label="Back">' + ICON_BACK + '</button>' +
          '<div class="wj-sheet__heading">' +
            '<p class="wj-sheet__progress"><span data-wj-progress></span><span class="wj-sheet__dots" aria-hidden="true" data-wj-dots></span></p>' +
            '<h2 id="WjSheetTitle" class="wj-sheet__title"></h2>' +
            '<p id="WjSheetSub" class="wj-sheet__sub"></p>' +
          '</div>' +
          '<button type="button" class="wj-sheet__icon wj-sheet__close" data-wj-close aria-label="Close">' + ICON_X + '</button>' +
        '</header>' +
        '<div class="wj-sheet__stage">' +
          '<div class="wj-sheet__page" data-wj-page="1">' +
            '<div class="wj-chips" role="group" aria-label="Filter pieces" data-wj-chips></div>' +
            '<div class="wj-grid" data-wj-grid></div>' +
          '</div>' +
          '<div class="wj-sheet__page" data-wj-page="2">' +
            '<div class="wj-prod">' +
              '<span class="wj-prod__media"><img data-wj-prod-img alt="" width="72" height="72" decoding="async"></span>' +
              '<span class="wj-prod__text"><strong class="wj-prod__name" data-wj-prod-name></strong>' +
              '<span class="wj-prod__sub" data-wj-prod-sub></span>' +
              '<span class="wj-prod__price"><span data-wj-prod-from></span><span data-wj-prod-price></span> <s class="wj-prod__was" data-wj-prod-was hidden></s></span></span>' + /* WAVY-CART-0928 */
            '</div>' +
            '<div class="wj-opts" data-wj-opts></div>' +
            '<button type="button" class="wj-btn" data-wj-continue disabled><span class="wj-btn__tick">' + ICON_TICK + '</span><span class="wj-btn__text" data-wj-continue-text>Continue</span></button>' +
          '</div>' +
          '<div class="wj-sheet__page" data-wj-page="3">' +
            '<div class="wj-pair" data-wj-pair></div>' +
            '<dl class="wj-math" data-wj-math></dl>' +
            '<button type="button" class="wj-btn" data-wj-confirm><span class="wj-btn__tick">' + ICON_TICK + '</span><span class="wj-btn__text" data-wj-confirm-text>Confirm pair</span></button>' +
          '</div>' +
          /* WAVY-CRO-1001B: step 0 "Your piece" (quick add). Last in the DOM so the step-1/2 queries still hit their own pages first */
          '<div class="wj-sheet__page wj-qa-piece" data-wj-page="0">' +
            '<div class="wj-prod">' +
              '<span class="wj-prod__media"><img data-wj-qa-img alt="" width="72" height="72" decoding="async"></span>' +
              '<span class="wj-prod__text"><strong class="wj-prod__name" data-wj-qa-name></strong>' +
              '<span class="wj-prod__sub" data-wj-qa-sub></span>' +
              '<span class="wj-prod__price"><span data-wj-qa-from></span><span data-wj-qa-price></span> <s class="wj-prod__was" data-wj-qa-was hidden></s></span></span>' +
            '</div>' +
            '<div class="wj-opts" data-wj-qa-opts></div>' +
            '<button type="button" class="wj-btn" data-wj-qa-go disabled><span class="wj-btn__tick">' + ICON_TICK + '</span><span class="wj-btn__text" data-wj-qa-go-text>Continue</span></button>' +
          '</div>' +
        '</div>' +
        '<p class="wj-sheet__status" role="status" aria-live="polite" data-wj-sheet-status></p>' +
      '</section>';
    document.body.appendChild(d);
    sh.root = d;
    return d;
  }
  function q(sel) { return sh.root.querySelector(sel); }
  function ctxProduct() { return sh.ctx && sh.ctx.map[sh.pid]; }
  function totalSteps() { return sh.ctx && sh.ctx.mode === 'drawer' ? 2 : 3; }
  function sheetStatus(msg) { var s = q('[data-wj-sheet-status]'); if (s) s.textContent = msg || ''; }

  /* catalogue for drawer mode: the drawer's nudge JSON (fresh each render) + the PDP catalogue when present */
  function drawerCatalog() {
    var map = {}, list = [];
    function take(data) {
      if (!data) return;
      setMoneyFormat(data.moneyFormat);
      (data.products || []).forEach(function (p) { if (p && p.variants && p.variants.length && !map[p.id]) { map[p.id] = p; list.push(p); } });
    }
    take(readJSON(document.querySelector('cart-drawer [data-wj-pair-catalog]') || document.querySelector('[data-wj-pair-catalog]')));
    take(readJSON(document.querySelector('[data-wj-bogo-catalog]')));
    return { map: map, list: list };
  }

  /* ---------------- step 1: grid ---------------- */
  function typeKey(p) { return /necklace|chain/i.test(p.type || '') ? 'chains' : (/bracelet/i.test(p.type || '') ? 'bracelets' : 'other'); }
  function currentPickPid() {
    if (!sh.ctx) return 0;
    if (sh.ctx.mode === 'pdp') return sh.ctx.st.slot2 ? sh.ctx.st.slot2.pid : 0;
    return sh.ctx.preselect || 0;
  }
  function renderChips() {
    var list = sh.ctx.list, has = { bracelets: 0, chains: 0 };
    list.forEach(function (p) { var k = typeKey(p); if (has[k] !== undefined) has[k] += 1; });
    var wrap = q('[data-wj-chips]');
    if (!has.bracelets || !has.chains) { wrap.hidden = true; wrap.innerHTML = ''; sh.filter = 'all'; return; }
    wrap.hidden = false;
    wrap.innerHTML = [['all', 'All'], ['bracelets', 'Bracelets'], ['chains', 'Chains']].map(function (c) {
      return '<button type="button" class="wj-chip" data-wj-chip="' + c[0] + '" aria-pressed="' + (sh.filter === c[0]) + '">' + c[1] + '</button>';
    }).join('');
  }
  function renderGrid() {
    var pick = currentPickPid();
    var list = sh.ctx.list.filter(function (p) { return sh.filter === 'all' || typeKey(p) === sh.filter; });
    q('[data-wj-grid]').innerHTML = list.map(function (p, i) {
      var from = minPrice(p.variants), varies = p.variants.some(function (v) { return v.price !== from; });
      var sel = p.id === pick;
      var price = (varies ? 'From ' : '') + formatMoney(from);
      /* WAVY-CART-0928: struck compare-at of that same from-variant */
      var lov = lowVariant(p.variants), was = lov && lov.compare > lov.price ? lov.compare : 0;
      return '<button type="button" class="wj-card' + (sel ? ' is-current' : '') + '" data-wj-pid="' + p.id + '" style="--i:' + i + '"' +
        ' aria-pressed="' + sel + '" aria-label="' + esc((p.full || p.title) + ', ' + price + (was ? ', was ' + formatMoney(was) : '')) + '">' +
        '<span class="wj-card__media">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" width="400" height="400" loading="eager" decoding="async">' : '') +
        '<span class="wj-card__tick" aria-hidden="true">' + ICON_TICK + '</span></span>' +
        '<span class="wj-card__name">' + esc(p.title) + '</span>' +
        (p.sub ? '<span class="wj-card__sub">' + esc(p.sub) + '</span>' : '') +
        '<span class="wj-card__price"><span>' + esc(price) + '</span>' + wasHTML(was, from, 'wj-card__was') + '</span></button>'; /* WAVY-CART-0928 */
    }).join('');
  }
  function setFilter(key) {
    if (key === sh.filter) return;
    sh.filter = key;
    q('[data-wj-chips]').querySelectorAll('[data-wj-chip]').forEach(function (c) { c.setAttribute('aria-pressed', String(c.getAttribute('data-wj-chip') === key)); });
    var grid = q('[data-wj-grid]');
    if (reduced()) { renderGrid(); fitStage(true); return; }
    grid.classList.add('is-swapping');
    clearTimeout(grid._wjT);
    grid._wjT = setTimeout(function () {
      renderGrid();
      grid.getBoundingClientRect();
      grid.classList.remove('is-swapping');
      fitStage();
    }, 120);
  }

  /* ---------------- step 2: options (SS23 grid; long values get fewer columns) ---------------- */
  function valueOk(p, i, val) {
    return p.variants.some(function (v) {
      if (v.options[i] !== val) return false;
      for (var k = 0; k < sh.sel.length; k++) if (k !== i && sh.sel[k] != null && v.options[k] !== sh.sel[k]) return false;
      return true;
    });
  }
  function matching(p) {
    return p.variants.filter(function (v) {
      for (var k = 0; k < sh.sel.length; k++) if (sh.sel[k] != null && v.options[k] !== sh.sel[k]) return false;
      return true;
    });
  }
  function resolved(p) {
    if (p.variants.length === 1) return p.variants[0];
    for (var k = 0; k < p.options.length; k++) if (sh.sel[k] == null) return null;
    var m = matching(p);
    return m.length === 1 ? m[0] : null;
  }
  function prefillSel(p, vid) {
    var v = vid && findVariant(p, vid);
    sh.sel = p.options.map(function (o, i) {
      if (v) return v.options[i];
      /* an option with one real value is already decided */
      var vals = o.values.filter(function (val) { return p.variants.some(function (x) { return x.options[i] === val; }); });
      return vals.length === 1 ? vals[0] : null;
    });
  }
  function colsFor(values) {
    var longest = values.reduce(function (m, v) { return Math.max(m, String(v).length); }, 0);
    return longest > 28 ? 'wj-pills--one' : (longest > 16 ? 'wj-pills--two' : '');
  }
  function renderOptions() {
    var p = ctxProduct();
    var img = q('[data-wj-prod-img]');
    if (p.img) { img.src = p.img; img.hidden = false; } else { img.removeAttribute('src'); img.hidden = true; }
    q('[data-wj-prod-name]').textContent = p.title;
    q('[data-wj-prod-sub]').textContent = p.sub || '';
    var price = q('[data-wj-prod-price]'); price._wjV = null;
    var html = '';
    /* WAVY-JADE-0926 SHEET: "Length: Select · Size guide" on step 2; the guide type follows the piece being picked */
    var sgType = /bracelet/i.test((p.sub || '') + ' ' + (p.title || '')) ? 'bracelet' : 'chain';
    var sgW = p.options.filter(function (o) { return /width/i.test(o.name); })[0];
    var sg = '<span class="wj-opt__sep" aria-hidden="true">·</span><button type="button" class="wj-sg-link" data-wj-sg' +
      ' data-wj-sg-type="' + sgType + '" data-wj-sg-widths="' + esc(sgW ? sgW.values.join(',') : '') + '"' +
      ' aria-haspopup="dialog" aria-controls="WjSizeGuide">Size guide</button>';
    if (!isDefaultOnly(p) && p.variants.length > 1) {
      html = p.options.map(function (o, i) {
        return '<fieldset class="wj-opt"><legend class="wj-opt__legend">' + esc(o.name) +
          '<span class="wj-opt__chosen" data-wj-chosen="' + i + '"></span>' + (i === 0 && window.wjSizeGuide ? sg : '') + '</legend><div class="wj-pills ' + colsFor(o.values) + '">' +
          o.values.map(function (val, j) {
            return '<button type="button" class="wj-vpill" data-wj-oi="' + i + '" data-wj-vi="' + j + '" style="--i:' + j + '" aria-pressed="false">' + esc(val) + '</button>';
          }).join('') + '</div></fieldset>';
      }).join('');
    }
    q('[data-wj-opts]').innerHTML = html;
    syncOptions();
  }
  function syncOptions() {
    var p = ctxProduct(); if (!p) return;
    sh.root.querySelectorAll('.wj-vpill[data-wj-oi]').forEach(function (b) { /* WAVY-CRO-1001B: step-2 pills only (step 0 pills carry data-wj-qa-oi) */
      var i = Number(b.getAttribute('data-wj-oi')), val = p.options[i].values[Number(b.getAttribute('data-wj-vi'))];
      var ok = valueOk(p, i, val), on = sh.sel[i] === val;
      b.setAttribute('aria-pressed', String(on));
      b.disabled = !ok;
      b.classList.toggle('is-struck', !ok);
      if (!ok) b.setAttribute('aria-label', val + ', unavailable with your other choices'); else b.removeAttribute('aria-label');
    });
    sh.root.querySelectorAll('[data-wj-chosen]').forEach(function (s) { var i = Number(s.getAttribute('data-wj-chosen')); s.textContent = ': ' + (sh.sel[i] != null ? sh.sel[i] : 'Select'); });
    var v = resolved(p);
    sh.vid = v ? v.id : 0;
    var m = v ? [v] : matching(p), lo = minPrice(m), varies = !v && m.some(function (x) { return x.price !== lo; });
    q('[data-wj-prod-from]').textContent = varies ? 'From ' : '';
    tween(q('[data-wj-prod-price]'), lo, formatMoney);
    var lov = lowVariant(m); setWas(q('[data-wj-prod-was]'), lov ? lov.compare : 0, lo); /* WAVY-CART-0928 */
    var btn = q('[data-wj-continue]'), t = q('[data-wj-continue-text]');
    btn.disabled = !v;
    btn.classList.remove('is-done');
    if (!v) {
      var miss = null;
      for (var k = 0; k < p.options.length; k++) if (sh.sel[k] == null) { miss = p.options[k].name; break; }
      t.textContent = miss ? selectLabel(miss) : 'Choose your options';
    } else if (sh.ctx.mode === 'drawer') t.textContent = 'Add to cart \u00b7 ' + formatMoney(quote(readCartUnits(null), [v.price]).pay);
    else t.textContent = 'Continue';
  }

  /* ---------------- step 3: option dropdown pills (WAVY-JADE-0926 PAIRDD) ----------------
     "p1" = this piece: a pick clicks the PDP picker's own radio, so Dawn's variant change + section render stay the one
     source of truth and the sheet, box, ATC and page picker can never disagree. "p2" = the second piece (sh.sel). */
  var ddOpen = null;
  function p1Sel(st) {
    return st.opts.map(function (o) {
      if (!o.fs.classList.contains('is-chosen')) return null;
      var c = o.fs.querySelector('input[type="radio"]:checked');
      return c ? c.value : null;
    });
  }
  function selOk(p, sel, i, val) {
    return p.variants.some(function (v) {
      if (v.options[i] !== val) return false;
      for (var k = 0; k < sel.length; k++) if (k !== i && sel[k] != null && v.options[k] !== sel[k]) return false;
      return true;
    });
  }
  function ddHTML(who, p, sel) {
    if (!p || isDefaultOnly(p) || p.variants.length < 2) return '';
    var html = p.options.map(function (o, i) {
      var vals = o.values.filter(function (val) { return p.variants.some(function (x) { return x.options[i] === val; }); });
      if (vals.length < 2) return '';
      var cur = sel[i] != null ? sel[i] : null;
      return '<div class="wj-dd"><button type="button" class="wj-dd__btn' + (cur == null ? ' is-pending' : '') + '" data-wj-dd="' + who + '" data-wj-oi="' + i + '"' +
        ' aria-haspopup="listbox" aria-expanded="false"><span class="wj-dd__name">' + esc(String(o.name).replace(/\s*\(.*\)\s*$/, '')) + ':</span> <span class="wj-dd__val">' +
        esc(cur == null ? 'Select' : cur) + '</span>' + ICON_CARET + '</button>' +
        '<div class="wj-dd__menu" role="listbox" aria-label="' + esc(o.name) + '" hidden><p class="wj-dd__label" aria-hidden="true">' + esc(o.name) + '</p>' +
        vals.map(function (val) {
          var ok = selOk(p, sel, i, val);
          return '<button type="button" role="option" class="wj-dd__opt" data-wj-dd-val="' + esc(val) + '" aria-selected="' + (val === cur) + '"' +
            (ok ? '' : ' disabled') + '><span>' + esc(val) + '</span>' + ICON_TICK + '</button>';
        }).join('') + '</div></div>';
    }).join('');
    return html ? '<div class="wj-dds">' + html + '</div>' : '';
  }
  function ddClose(focusBtn) {
    if (!ddOpen) return;
    var b = ddOpen; ddOpen = null;
    if (!b.isConnected) return;
    b.setAttribute('aria-expanded', 'false');
    b.parentNode.classList.remove('is-open');
    b.nextElementSibling.hidden = true;
    if (focusBtn) b.focus({ preventScroll: true });
  }
  function ddToggle(btn) {
    if (ddOpen === btn) { ddClose(); return; }
    ddClose();
    ddOpen = btn;
    var m = btn.nextElementSibling;
    btn.setAttribute('aria-expanded', 'true');
    m.hidden = false;
    btn.parentNode.classList.add('is-open');
    var f = m.querySelector('.wj-dd__opt[aria-selected="true"]:not([disabled])') || m.querySelector('.wj-dd__opt:not([disabled])');
    if (f) f.focus({ preventScroll: true });
  }
  /* WAVY-CRO-1001B: set option i of THIS piece (the page picker's own radios) to val. Extracted unchanged from ddPick's p1 branch. */
  function pickP1(st, i, val) {
    var o = st.opts[i], p1 = st.map[st.pid], want = p1Sel(st);
    want[i] = val;
    /* pending options keep Dawn's default radios checked; steer them (no click: they stay pending) to an AVAILABLE
       variant carrying this value, so the page never resolves to a missing or sold-out combination */
    var target = p1 && p1.variants.filter(function (v) {
      for (var k = 0; k < want.length; k++) if (want[k] != null && v.options[k] !== want[k]) return false;
      return true;
    })[0];
    var steered = false; /* WAVY-CRO-1001B review fix: remember silent re-checks so the page re-reads its variant */
    if (target) st.opts.forEach(function (oo, k) {
      if (k === i || oo.fs.classList.contains('is-chosen')) return;
      var rr = Array.prototype.filter.call(oo.fs.querySelectorAll('input[type="radio"]'), function (x) { return x.value === target.options[k]; })[0];
      if (rr && !rr.checked) { rr.checked = true; steered = true; }
    });
    var r = o && Array.prototype.filter.call(o.fs.querySelectorAll('input[type="radio"]'), function (x) { return x.value === val; })[0];
    /* an unchecked radio: click = the page picker's own path (our click listener marks it chosen, Dawn re-renders).
       WAVY-CRO-1001B: if this value was already checked but other radios were re-checked silently, fire change so Dawn's
       hidden variant id follows the radios (otherwise the old variant could be added on 3+ option products). */
    if (r) {
      if (r.checked) { markChosen(st, o.fs); if (steered) r.dispatchEvent(new Event('change', { bubbles: true })); }
      else r.click();
    }
  }
  function ddPick(opt) {
    var btn = opt.closest('.wj-dd').querySelector('[data-wj-dd]');
    var who = btn.getAttribute('data-wj-dd'), i = Number(btn.getAttribute('data-wj-oi')), val = opt.getAttribute('data-wj-dd-val');
    var boxEl = btn.closest('[data-wj-bogo]'), st = boxEl ? boxEl._wj : sh.ctx.st;
    ddClose();
    if (who === 'p2') {
      sh.sel[i] = val;
      syncOptions(); /* step 2 pills + sh.vid follow */
    } else if (who === 'b2') {
      var d2 = slot2Data(st);
      var nv = d2 && d2.p.variants.filter(function (v) {
        for (var k = 0; k < v.options.length; k++) if (v.options[k] !== (k === i ? val : d2.v.options[k])) return false;
        return true;
      })[0];
      if (nv) { st.slot2.vid = nv.id; paintSlot2(st, false); paintBox(st); }
    } else {
      pickP1(st, i, val); /* WAVY-CRO-1001B: the body moved into pickP1 (shared with the quick-add sheet's step 0) */
    }
    if (!boxEl) renderPair();
    var nb = (boxEl || sh.root).querySelector('[data-wj-dd="' + who + '"][data-wj-oi="' + i + '"]');
    if (nb) nb.focus({ preventScroll: true });
    if (!boxEl) fitStage();
  }
  /* shared dropdown keys (sheet + box); true when handled */
  function ddKeys(e) {
    if (!ddOpen) return false;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); sh.escAt = Date.now(); ddClose(true); return true; }
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Home' || e.key === 'End') {
      var os = Array.prototype.slice.call(ddOpen.nextElementSibling.querySelectorAll('.wj-dd__opt:not([disabled])'));
      if (os.length) {
        e.preventDefault();
        var at = os.indexOf(document.activeElement);
        var nx = e.key === 'Home' ? 0 : e.key === 'End' ? os.length - 1
          : e.key === 'ArrowDown' ? (at + 1) % os.length : (at <= 0 ? os.length - 1 : at - 1);
        os[nx].focus({ preventScroll: true });
      }
      return true;
    }
    if (e.key === 'Tab') ddClose();
    return false;
  }
  /* the box repainted (page picker change, fresh section render, cart change) while step 3 is showing */
  function refreshPair(st) {
    var r = sh.root;
    if (!r || r.hidden || !r.classList.contains('is-open') || sh.step !== 3 || !sh.ctx || sh.ctx.st !== st) return;
    var c = q('[data-wj-confirm]'); if (c && c.classList.contains('is-done')) return;
    var a = document.activeElement, w = a && a.closest && a.closest('.wj-dd'), b = w && w.querySelector('[data-wj-dd]');
    var who = b && b.getAttribute('data-wj-dd'), oi = b && b.getAttribute('data-wj-oi'), wasOpen = !!b && ddOpen === b;
    renderPair();
    if (who) {
      var nb = q('[data-wj-dd="' + who + '"][data-wj-oi="' + oi + '"]');
      if (nb) { if (wasOpen) ddToggle(nb); else nb.focus({ preventScroll: true }); }
    }
    fitStage();
  }

  /* ---------------- step 3: the pair ---------------- */
  function renderPair() {
    var st = sh.ctx.st, v1 = slot1Variant(st), p1 = st.map[st.pid];
    var p2 = ctxProduct(), v2 = findVariant(p2, sh.vid);
    if (!v1 || !v2) { var cb = q('[data-wj-confirm]'); if (cb) cb.disabled = true; return; }
    ddOpen = null;
    var cart = st.cart || [], qp = quote(cart, [v1.price, v2.price]), m = pairMath(v1.price, v2.price);
    var v1Label = pending(st).length ? 'Choose options' : varLabel(v1);
    var dd1 = p1 && st.opts.length === p1.options.length ? ddHTML('p1', p1, p1Sel(st)) : '', dd2 = ddHTML('p2', p2, sh.sel);
    var halves = halvesAddUp(qp, [v1.price, v2.price]);
    function piece(name, vt, img, price, off, label, dd, compare) {
      return '<div class="wj-pair__piece' + (off ? ' is-off' : '') + '">' +
        '<span class="wj-pair__media">' + (img ? '<img src="' + esc(img) + '" alt="" width="160" height="160" decoding="async">' : '') + '</span>' +
        '<span class="wj-pair__num">' + label + '</span>' +
        '<strong class="wj-pair__name">' + esc(name) + '</strong>' +
        (dd || (vt ? '<span class="wj-pair__var">' + esc(vt) + '</span>' : '')) +
        '<span class="wj-pair__price">' + slotPriceHTML(price, off, halves, compare) + '</span>' +
        '</div>';
    }
    q('[data-wj-pair]').innerHTML =
      piece(p1 ? p1.title : '', v1Label, v1.img || (p1 && p1.img), v1.price, qp.off[0], 'This piece', dd1, v1.compare) +
      '<span class="wj-pair__join" aria-hidden="true">+</span>' +
      piece(p2.title, varLabel(v2), p2.img, v2.price, qp.off[1], 'Second piece', dd2, v2.compare);
    q('[data-wj-math]').innerHTML = (cart.length
      ? '<div class="wj-math__row"><dt>Both pieces</dt><dd>' + esc(formatMoney(qp.strike)) + '</dd></div>' +
        '<div class="wj-math__row"><dt>50% off, with the jade in your cart</dt><dd>' + (qp.save > 0 ? '-' : '') + esc(formatMoney(Math.abs(qp.save))) + '</dd></div>'
      : '<div class="wj-math__row"><dt>Full price</dt><dd>' + esc(formatMoney(m.hi)) + '</dd></div>' +
        '<div class="wj-math__row"><dt>50% off</dt><dd><s>' + esc(formatMoney(m.lo)) + '</s> ' + esc(formatMoney(m.half)) + '</dd></div>') +
      '<div class="wj-math__row wj-math__row--pay"><dt>You pay</dt><dd>' + esc(formatMoney(qp.pay)) + '</dd></div>' +
      (qp.save > 0 ? '<div class="wj-math__row wj-math__row--save"><dt>You save</dt><dd>' + esc(formatMoney(qp.save)) + '</dd></div>' : '');
    var c = q('[data-wj-confirm]');
    c.classList.remove('is-done'); c.disabled = false;
    q('[data-wj-confirm-text]').textContent = 'Confirm pair';
  }

  /* ---------------- pages ---------------- */
  var TITLES = { 0: 'Your piece', 1: 'Choose your second piece', 2: 'Your options', 3: 'Your pair' }; /* WAVY-CRO-1001B: 0 = quick-add step */
  function fitStage(instant) {
    var stage = q('.wj-sheet__stage'), page = q('.wj-sheet__page.is-active');
    if (!stage || !page) return;
    var from = stage.getBoundingClientRect().height, to = page.offsetHeight + 12;
    if (instant || reduced() || !from) {
      stage.style.transition = 'none'; stage.style.height = to + 'px'; stage.getBoundingClientRect(); stage.style.transition = '';
    } else { stage.style.height = from + 'px'; stage.getBoundingClientRect(); stage.style.height = to + 'px'; }
  }
  function setPage(n, instant) {
    ddClose();
    sh.step = n;
    sh.root.querySelectorAll('[data-wj-page]').forEach(function (p) {
      var i = Number(p.getAttribute('data-wj-page'));
      p.classList.toggle('is-active', i === n);
      p.classList.toggle('is-before', i < n);
      p.classList.toggle('is-after', i > n);
      p.inert = i !== n;
    });
    /* WAVY-CRO-1001B: step 0 ("Your piece") counts as step 1 when it leads a pair flow (lead), and the progress hides for the one-step single flow */
    var lead = sh.ctx.lead ? 1 : 0, total = totalSteps() + lead, drawer = sh.ctx.mode === 'drawer', p = n === 0 ? pieceProduct() : ctxProduct();
    var pos = n === 0 ? 1 : n + lead;
    q('[data-wj-back]').classList.toggle('is-shown', n > minStep());
    q('[data-wj-progress]').textContent = 'Step ' + pos + ' of ' + total;
    q('.wj-sheet__progress').hidden = !!sh.ctx.single;
    if (n === 0) syncPiece();
    var dots = '';
    for (var i = 1; i <= total; i++) dots += '<i class="' + (i < pos ? 'is-done' : (i === pos ? 'is-on' : '')) + '"></i>';
    q('[data-wj-dots]').innerHTML = dots;
    q('.wj-sheet__title').textContent = n === 1 && drawer ? 'Choose a piece' : TITLES[n];
    q('.wj-sheet__sub').textContent =
      n === 0 ? (p ? (p.full || p.title) : '') :
      n === 1 ? (drawer ? 'The lower-priced piece of your pair is 50% off.' : 'Mix any two jade pieces. The lower-priced one is 50% off.')
      : n === 2 ? (p ? (p.full || p.title) : '')
      : 'Buy one, get one 50% off'; /* WAVY-CRO-1001: one short line (was two sentences) */
    sheetStatus('');
    fitStage(instant);
    setTimeout(function () {
      if (!sh.root || sh.root.hidden) return;
      /* WAVY-CRO-1001B: step 0 focus target; step 2 queries scoped to their page (step 0 pills share the .wj-vpill class) */
      var f = n === 0 ? (q('[data-wj-page="0"] .wj-vpill[aria-pressed="false"]:not([disabled])') || q('[data-wj-qa-go]:not([disabled])'))
        : n === 1 ? (q('.wj-card[aria-pressed="true"]') || q('.wj-card'))
        : n === 2 ? (q('[data-wj-page="2"] .wj-vpill[aria-pressed="false"]:not([disabled])') || q('[data-wj-continue]:not([disabled])') || q('[data-wj-page="2"] .wj-vpill'))
        : q('[data-wj-confirm]');
      if (f) f.focus({ preventScroll: true });
    }, instant || reduced() ? 0 : 260);
  }

  /* ---------------- open / close ---------------- */
  var lockPad = '';
  /* lock BODY, not <html>: base.css forces body{overflow-x:hidden !important}, and an html lock unpins the sticky
     header / product columns. The scrollbar width becomes body padding so nothing shifts. */
  function lockScroll(on) {
    var h = document.documentElement, b = document.body;
    if (on) {
      if (b.classList.contains('wj-lock')) return;
      var sbw = window.innerWidth - h.clientWidth;
      lockPad = b.style.paddingRight;
      if (sbw > 0) b.style.paddingRight = sbw + 'px';
      b.classList.add('wj-lock');
    } else { b.classList.remove('wj-lock'); b.style.paddingRight = lockPad; }
  }
  function openSheet(o) {
    clearTimeout(sh.closeT);
    var r = sheetRoot();
    if (o.mode === 'drawer') {
      var cat = drawerCatalog();
      sh.ctx = { mode: 'drawer', st: null, map: cat.map, list: cat.list, preselect: o.pid || 0 };
    } else {
      sh.ctx = { mode: 'pdp', st: o.st, map: o.st.map, list: o.st.list, lead: !!o.lead, single: !!o.single }; /* WAVY-CRO-1001B: lead = step 0 precedes the pair steps, single = step 0 only */
    }
    if (!sh.ctx.list.length) return false;
    sh.trigger = o.trigger || document.activeElement;
    sh.openId += 1;
    sh.filter = 'all';
    var step = o.step === 0 ? 0 : (o.step || 1); /* WAVY-CRO-1001B: 0 = "Your piece" */
    var pid = o.pid || (sh.ctx.mode === 'pdp' && o.st.slot2 ? o.st.slot2.pid : 0);
    sh.pid = sh.ctx.map[pid] ? pid : 0;
    if (step >= 2 && !sh.pid) step = 1;
    if (!sh.ctx.single) { renderChips(); renderGrid(); } /* WAVY-CRO-1001B: the one-step single flow never shows the grid */
    if (step === 0) renderPiece();
    if (step >= 2) {
      var pre = sh.ctx.mode === 'pdp' && o.st.slot2 && o.st.slot2.pid === sh.pid ? o.st.slot2.vid : 0;
      prefillSel(ctxProduct(), pre);
      renderOptions();
      if (step === 3 && sh.ctx.mode === 'pdp' && sh.vid) renderPair(); else if (step === 3) step = 2;
    }
    r.classList.remove('is-open', 'is-leaving');
    r.hidden = false;
    lockScroll(true);
    setPage(step, true);
    r.getBoundingClientRect(); /* resolve the closed styles, then transition without rAF */
    r.classList.add('is-open');
    /* focus moves into the dialog at once, so an early Escape never reaches the cart drawer's keyup handler */
    r.querySelector('.wj-sheet__panel').focus({ preventScroll: true });
    var ev = { mode: sh.ctx.mode, step: step }; if (sh.pid) ev.product_id = sh.pid; track('open', ev);
    return true;
  }
  function closeSheet(restore) {
    var r = sh.root; if (!r || r.hidden) return;
    r.classList.remove('is-open');
    r.classList.add('is-leaving');
    lockScroll(false);
    var trigger = sh.trigger;
    sh.closeT = setTimeout(function () {
      var a = document.activeElement;
      if (a && r.contains(a) && a.blur) a.blur(); /* never leave focus inside a hidden sheet */
      r.hidden = true;
      r.classList.remove('is-leaving');
      if (restore === false) return;
      if (trigger && trigger.isConnected) {
        trigger.focus({ preventScroll: true });
        /* WAVY-CRO-1001B: the sticky bar (trigger) may still be inert/hidden: fall back to the page's own add button */
        if (document.activeElement !== trigger && sh.ctx && sh.ctx.st && sh.ctx.st.btn) sh.ctx.st.btn.focus({ preventScroll: true });
      } else { var inner = document.querySelector('cart-drawer.active .drawer__inner'); if (inner) inner.focus({ preventScroll: true }); }
    }, reduced() ? 0 : 240);
  }

  function pickProduct(p, card) {
    sh.pid = p.id;
    sh.root.querySelectorAll('.wj-card').forEach(function (c) { c.setAttribute('aria-pressed', String(c === card)); c.classList.toggle('is-current', c === card); });
    if (p.variants.length === 1) {
      /* one sellable variant: no options to ask about */
      sh.vid = p.variants[0].id;
      prefillSel(p, sh.vid);
      if (sh.ctx.mode === 'drawer') { drawerAdd(card); return; }
      renderOptions();
      renderPair();
      setPage(3);
      return;
    }
    var pre = sh.ctx.mode === 'pdp' && sh.ctx.st.slot2 && sh.ctx.st.slot2.pid === p.id ? sh.ctx.st.slot2.vid : 0;
    prefillSel(p, pre);
    renderOptions();
    setPage(2);
  }
  function doneState(btn, text) {
    if (!btn) return;
    btn.classList.add('is-done');
    var t = btn.querySelector('.wj-btn__text'); if (t) t.textContent = text;
    if (btn.classList.contains('wj-card')) btn.classList.add('is-chosen');
  }
  function commitPair() {
    var st = sh.ctx.st, pid = sh.pid, vid = sh.vid, openId = sh.openId;
    doneState(q('[data-wj-confirm]'), 'Added to your pair');
    track('pick', { product_id: st.pid, second_product_id: pid });
    setTimeout(function () {
      st.slot2 = { pid: pid, vid: vid };
      setStatus(st, '');
      /* the slot button is re-rendered in place, so focus returns to it unless the ATC opened us */
      var fromSlot = sh.trigger && st.box.contains(sh.trigger);
      if (openId === sh.openId) closeSheet(!fromSlot);
      setTimeout(function () {
        paintSlot2(st, true);
        paintBox(st);
        if (fromSlot) { var ch = st.box.querySelector('[data-wj-slot="2"] [data-wj-open-sheet], [data-wj-slot="2"]'); if (ch) ch.focus({ preventScroll: true }); }
      }, reduced() ? 0 : 140);
    }, reduced() ? 0 : 260);
  }
  function drawerAdd(btn) {
    if (sh.busy || !sh.vid) return;
    sh.busy = true;
    sheetStatus('');
    if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); }
    var vid = sh.vid, pid = sh.pid, p = ctxProduct(), v = p && findVariant(p, vid), openId = sh.openId;
    var qd = v ? quote(readCartUnits(null), [v.price]) : null;
    addItems([{ id: vid, quantity: 1 }], {}).then(function () {
      var ev = { mode: 'drawer', product_id: pid }; if (qd) ev.value = qd.pay / 100;
      track('add', ev);
      doneState(btn, 'Added');
      setTimeout(function () { if (openId === sh.openId) closeSheet(); }, reduced() ? 0 : 260);
    }).catch(function (err) {
      sheetStatus((err && err.message) || 'That piece couldn\u2019t be added. Please try again.');
    }).then(function () {
      sh.busy = false;
      if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); }
    });
  }

  /* ---------------- WAVY-CRO-1001B: quick-add sheet, step 0 "Your piece" ----------------
     Single source of truth = the page picker (st.opts radios + is-chosen). A pill pick goes through pickP1 (the radio's own click),
     and every repaint of the box re-reads the picker (refreshPiece -> syncPiece), so the sheet can never disagree with the page. */
  function minStep() { return sh.ctx && (sh.ctx.lead || sh.ctx.single) ? 0 : 1; }
  function pieceProduct() { return sh.ctx && sh.ctx.st ? sh.ctx.st.map[sh.ctx.st.pid] : null; }
  function selMatch(p, sel) {
    return p.variants.filter(function (v) {
      for (var k = 0; k < sel.length; k++) if (sel[k] != null && v.options[k] !== sel[k]) return false;
      return true;
    });
  }
  function selResolve(p, sel) {
    if (p.variants.length === 1) return p.variants[0];
    for (var k = 0; k < p.options.length; k++) if (sel[k] == null) return null;
    var m = selMatch(p, sel);
    return m.length === 1 ? m[0] : null;
  }
  /* open the sheet at step 0 for the current box. false = cannot (no catalogue entry / picker mismatch): the caller keeps the old nudge */
  function openQuick(st, trigger) {
    var p1 = st && st.map[st.pid];
    if (!p1 || !st.opts.length || st.opts.length !== p1.options.length) return false;
    var single = st.mode === 'single';
    return openSheet({ st: st, mode: 'pdp', step: 0, single: single, lead: !single, trigger: trigger || st.btn });
  }
  function renderPiece() {
    var st = sh.ctx.st, p = pieceProduct(); if (!p) return;
    q('[data-wj-qa-name]').textContent = p.title;
    q('[data-wj-qa-sub]').textContent = p.sub || '';
    var price = q('[data-wj-qa-price]'); price._wjV = null;
    var sgType = st.box.getAttribute('data-wj-sg-type') || 'bracelet', sgW = st.box.getAttribute('data-wj-sg-widths') || '';
    var sg = '<span class="wj-opt__sep" aria-hidden="true">·</span><button type="button" class="wj-sg-link" data-wj-sg' +
      ' data-wj-sg-type="' + esc(sgType) + '" data-wj-sg-widths="' + esc(sgW) + '" aria-haspopup="dialog" aria-controls="WjSizeGuide">Size guide</button>';
    var html = '';
    p.options.forEach(function (o, i) {
      var po = st.opts[i]; if (!po || !po.multi) return; /* one-value options are already decided */
      html += '<fieldset class="wj-opt"><legend class="wj-opt__legend">' + esc(o.name) +
        '<span class="wj-opt__chosen" data-wj-qa-chosen="' + i + '"></span>' + (i === 0 && window.wjSizeGuide ? sg : '') + '</legend><div class="wj-pills ' + colsFor(o.values) + '">' +
        o.values.map(function (val, j) {
          return '<button type="button" class="wj-vpill" data-wj-qa-oi="' + i + '" data-wj-qa-vi="' + j + '" style="--i:' + j + '" aria-pressed="false">' + esc(val) + '</button>';
        }).join('') + '</div></fieldset>';
    });
    q('[data-wj-qa-opts]').innerHTML = html;
    var go = q('[data-wj-qa-go]'); go.classList.remove('is-done', 'is-busy'); go.removeAttribute('aria-busy');
    syncPiece();
  }
  function syncPiece() {
    var r = sh.root; if (!r || !sh.ctx || !sh.ctx.st) return;
    var st = sh.ctx.st, p = pieceProduct(); if (!p) return;
    var sel = p1Sel(st);
    r.querySelectorAll('[data-wj-qa-oi]').forEach(function (b) {
      var i = Number(b.getAttribute('data-wj-qa-oi')), val = p.options[i].values[Number(b.getAttribute('data-wj-qa-vi'))];
      var ok = selOk(p, sel, i, val), on = sel[i] === val;
      b.setAttribute('aria-pressed', String(on));
      b.disabled = !ok;
      b.classList.toggle('is-struck', !ok);
      if (!ok) b.setAttribute('aria-label', val + ', unavailable with your other choices'); else b.removeAttribute('aria-label');
    });
    r.querySelectorAll('[data-wj-qa-chosen]').forEach(function (s) { var i = Number(s.getAttribute('data-wj-qa-chosen')); s.textContent = ': ' + (sel[i] != null ? sel[i] : 'Select'); });
    var v = pending(st).length ? null : selResolve(p, sel); /* WAVY-CRO-1001B review fix: never unlock while page options are unpicked */
    var m = v ? [v] : selMatch(p, sel), lo = minPrice(m), varies = !v && m.some(function (x) { return x.price !== lo; });
    q('[data-wj-qa-from]').textContent = varies ? 'From ' : '';
    tween(q('[data-wj-qa-price]'), lo, formatMoney);
    var lov = lowVariant(m); setWas(q('[data-wj-qa-was]'), lov ? lov.compare : 0, lo);
    var cv = v && curVariant(st, v.id), src = (cv && cv.img) || p.img, img = q('[data-wj-qa-img]');
    if (src) { if (img.getAttribute('src') !== src) img.src = src; img.hidden = false; } else { img.removeAttribute('src'); img.hidden = true; }
    var go = q('[data-wj-qa-go]'), gt = q('[data-wj-qa-go-text]');
    if (sh.busy || go.classList.contains('is-done')) return;
    go.disabled = !v;
    if (!v) {
      var miss = null;
      for (var k = 0; k < p.options.length; k++) if (st.opts[k] && st.opts[k].multi && sel[k] == null) { miss = p.options[k].name; break; }
      gt.textContent = miss ? selectLabel(miss) : 'Choose your options';
    } else gt.textContent = sh.ctx.single ? 'Add to cart · ' + formatMoney(quote(st.cart || [], [v.price]).pay) : 'Continue';
  }
  function refreshPiece(st) {
    var r = sh.root;
    if (!r || r.hidden || !r.classList.contains('is-open') || sh.step !== 0 || !sh.ctx || sh.ctx.st !== st) return;
    syncPiece();
  }
  function qaPick(btn) {
    var st = sh.ctx && sh.ctx.st, p = pieceProduct(); if (!st || !p) return;
    var i = Number(btn.getAttribute('data-wj-qa-oi')), val = p.options[i].values[Number(btn.getAttribute('data-wj-qa-vi'))];
    sheetStatus('');
    pickP1(st, i, val);
    syncPiece();
  }
  /* the step-0 button: single = add to cart (same /cart/add.js path + drawer hand-off as the main button); pair = on to the second piece */
  function qaGo(btn) {
    var st = sh.ctx.st;
    if (sh.ctx.single) { qaAdd(btn); return; }
    var s2 = st.slot2, p2 = s2 && sh.ctx.map[s2.pid];
    if (p2 && findVariant(p2, s2.vid)) {
      /* a second piece is already chosen: straight to the pair review */
      sh.pid = p2.id; prefillSel(p2, s2.vid); renderOptions(); renderPair(); setPage(3);
    } else setPage(1);
  }
  function qaAdd(btn) {
    var st = sh.ctx.st; if (sh.busy || st.busy) return;
    var v1 = slot1Variant(st);
    if (st.unavail || pending(st).length || !v1 || !v1.available) { sheetStatus('Choose your options to continue.'); return; }
    var openId = sh.openId, qv = quote(st.cart, [v1.price]);
    sh.busy = true; setBusy(st, true); sheetStatus('');
    btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true');
    addItems([{ id: v1.id, quantity: 1 }], { trigger: st.btn }).then(function () {
      track('add', { mode: 'single', product_id: st.pid, value: qv.pay / 100, via: 'quick' });
      setAdded(st);
      doneState(btn, 'Added');
      /* focus stays wherever the cart drawer put it */
      setTimeout(function () { if (openId === sh.openId) closeSheet(false); }, reduced() ? 0 : 260);
    }).catch(function (err) {
      sheetStatus((err && err.message) || 'That piece couldn’t be added. Please try again.');
    }).then(function () {
      sh.busy = false; setBusy(st, false);
      btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy');
    });
  }

  /* ================================ events ================================ */
  document.addEventListener('change', function (e) {
    var input = e.target && e.target.closest && e.target.closest('[data-wj-tier-input]');
    if (!input) return;
    var box = input.closest('[data-wj-bogo]'); if (!box || !box._wj) return;
    var st = box._wj;
    st.mode = input.value;
    setStatus(st, '');
    paintBox(st);
  });

  /* choose-first: a pick (click on a pill, or an arrow-key change) marks that option chosen */
  function pickerBox(el) {
    var picker = el.closest('variant-radios, variant-selects'); if (!picker) return null;
    var sec = picker.getAttribute('data-section');
    for (var i = 0; i < boxes.length; i++) if (!sec || !boxes[i].section || boxes[i].section === sec) return boxes[i];
    return null;
  }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var lab = t.closest('variant-radios label, variant-radios input[type="radio"]');
    if (!lab) return;
    var st = pickerBox(lab); if (!st) return;
    markChosen(st, lab.closest('fieldset'));
  });
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || !t.closest || !t.matches || !t.matches('variant-radios input[type="radio"]')) return;
    var st = pickerBox(t); if (!st) return;
    markChosen(st, t.closest('fieldset'));
  });

  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    if (ddOpen && ddOpen.closest('[data-wj-bogo]') && !t.closest('.wj-dd')) ddClose();
    if (!t.closest('[data-wj-bogo]')) return;
    var ddb = t.closest('[data-wj-dd]');
    if (ddb) { e.preventDefault(); ddToggle(ddb); return; }
    var ddo = t.closest('.wj-dd__opt');
    if (ddo) { e.preventDefault(); if (!ddo.disabled) ddPick(ddo); }
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var opener = t.closest('[data-wj-open-sheet]');
    if (opener) {
      var box = opener.closest('[data-wj-bogo]');
      if (box && box._wj) { e.preventDefault(); openSheet({ st: box._wj, mode: 'pdp', step: 1, trigger: opener }); }
      return;
    }
    if (!sh.root || sh.root.hidden || !sh.root.contains(t)) return;
    if (t.closest('[data-wj-close]')) { closeSheet(); return; }
    if (t.closest('[data-wj-back]')) { if (sh.step > minStep()) setPage(sh.step - 1); return; } /* WAVY-CRO-1001B: minStep */
    var ddb = t.closest('[data-wj-dd]');
    if (ddb) { ddToggle(ddb); return; }
    var ddo = t.closest('.wj-dd__opt');
    if (ddo) { if (!ddo.disabled) ddPick(ddo); return; }
    if (ddOpen && !t.closest('.wj-dd')) ddClose();
    var chip = t.closest('[data-wj-chip]');
    if (chip) { setFilter(chip.getAttribute('data-wj-chip')); return; }
    var card = t.closest('[data-wj-pid]');
    if (card) { var p = sh.ctx.map[Number(card.getAttribute('data-wj-pid'))]; if (p) pickProduct(p, card); return; }
    /* WAVY-CRO-1001B: step 0 pill / its button */
    var qpill = t.closest('[data-wj-qa-oi]');
    if (qpill) { if (!qpill.disabled) qaPick(qpill); return; }
    var qgo = t.closest('[data-wj-qa-go]');
    if (qgo) { if (!qgo.disabled && !qgo.classList.contains('is-done')) qaGo(qgo); return; }
    var pill = t.closest('.wj-vpill');
    if (pill && !pill.disabled) {
      var pp = ctxProduct(), i = Number(pill.getAttribute('data-wj-oi'));
      sh.sel[i] = pp.options[i].values[Number(pill.getAttribute('data-wj-vi'))];
      syncOptions();
      return;
    }
    var cont = t.closest('[data-wj-continue]');
    if (cont && !cont.disabled && sh.vid) {
      if (sh.ctx.mode === 'drawer') drawerAdd(cont);
      else { renderPair(); setPage(3); }
      return;
    }
    var conf = t.closest('[data-wj-confirm]');
    if (conf && !conf.disabled && !conf.classList.contains('is-done')) { conf.disabled = true; commitPair(); }
  });

  document.addEventListener('keydown', function (e) {
    if (ddOpen && ddOpen.closest('[data-wj-bogo]')) { ddKeys(e); return; } /* a box dropdown (sheet closed) */
    var r = sh.root; if (!r || r.hidden || r.classList.contains('is-leaving')) return;
    if (window.wjSizeGuide && window.wjSizeGuide.isOpen && window.wjSizeGuide.isOpen()) return; /* the guide sits above us */
    if (ddKeys(e)) return;
    if (e.key === 'Escape') {
      e.preventDefault(); e.stopPropagation();
      sh.escAt = Date.now();
      if (sh.step > minStep()) setPage(sh.step - 1); else closeSheet(); /* WAVY-CRO-1001B: minStep */
      return;
    }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(r.querySelectorAll('.wj-sheet__panel button:not([disabled]), .wj-sheet__panel [href]'), function (b) {
      return b.offsetParent !== null && !b.closest('[inert]') && getComputedStyle(b).visibility !== 'hidden';
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (!r.contains(a)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }, true);

  /* the matching Escape keyup must not reach cart-drawer's keyup close handler (the sheet may already be closing) */
  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape' || !sh.root) return;
    if (!sh.root.hidden || Date.now() - sh.escAt < 600) e.stopPropagation();
  }, true);

  /* a picker change that did NOT update the hidden id means global.js found no variant (unavailable combo).
     Element listeners (VariantSelects.onVariantChange) run before this document-level bubble listener. */
  document.addEventListener('change', function (e) {
    var picker = e.target && e.target.closest && e.target.closest('variant-radios, variant-selects');
    if (!picker) return;
    boxes.forEach(function (st) {
      if (st.section && picker.getAttribute('data-section') !== st.section) return;
      var un = !st.gotInput;
      st.gotInput = false;
      if (un !== st.unavail) { st.unavail = un; if (un) setStatus(st, ''); paintBox(st); }
    });
  });

  /* ATC intercept: capture phase, both tiers (one add path, one status line, one busy/added state).
     The native product-form never runs on jade PDPs; its hidden variant id stays for the no-JS select. */
  document.addEventListener('submit', function (e) {
    var form = e.target, st = form && form._wjBogo;
    if (!st) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addNow(st);
  }, true);

  /* ================================ boot + API ================================ */
  function boot(root) { (root || document).querySelectorAll('[data-wj-bogo]').forEach(initBox); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  /* PUB_SUB variantChange fires after the theme's section fetch with the parsed document: the price-sync source */
  function subscribeVariant() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
      var d = ev && ev.data; if (!d) return;
      boxes.forEach(function (st) {
        if (st.section && d.sectionId && d.sectionId !== st.section) return;
        applyFreshRender(st, d.html, d.variant);
      });
    });
  }
  function refreshCartUnits() {
    boxes.forEach(function (st) {
      var next = readCartUnits(st);
      if (next.join(',') === (st.cart || []).join(',')) return;
      st.cart = next;
      paintBox(st);
    });
  }
  function subscribeCart() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    /* product-form publishes BEFORE renderContents, cart-items AFTER: read on the next task either way */
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refreshCartUnits, 0); });
  }
  document.addEventListener('wj:cart-rendered', refreshCartUnits);
  /* WAVY-CRO-1001: repaint (ATC free-shipping line) after a currency change without a reload, and on a bfcache restore */
  function repaintAll() { boxes.forEach(paintBox); }
  document.addEventListener('wj:currency-changed', repaintAll);
  window.addEventListener('pageshow', function (e) { if (e.persisted) repaintAll(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', subscribeCart); else subscribeCart();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', subscribeVariant); else subscribeVariant();

  window.wjBogo = {
    version: 'WAVY-JADE-0926',
    /* o: {preselectProductId, step (1-3), mode ('pdp' | 'drawer'), trigger}. Returns true when the sheet opened. */
    open: function (o) {
      o = o || {};
      var mode = o.mode === 'drawer' ? 'drawer' : 'pdp';
      var st = boxes[0];
      if (mode === 'pdp' && !st) mode = 'drawer';
      return openSheet({ mode: mode, st: st, step: Number(o.step) || 1, pid: Number(o.preselectProductId) || 0, trigger: o.trigger });
    },
    close: function () { closeSheet(); },
    /* WAVY-CRO-1001B: open the quick-add sheet at "Your piece" for the PDP box; true when it opened (sticky bar uses this) */
    quickAdd: function (o) { var st = boxes[0]; return !!st && openQuick(st, o && o.trigger); },
    addItems: addItems,
    formatMoney: formatMoney,
    pairMath: pairMath,
    quote: quote,
    halfOff: halfOff,
    selectLabel: selectLabel,
    track: track,
    refresh: repaintAll /* WAVY-CRO-1001: call after window.Shopify.currency changes */
  };
})();
